'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

/**
 * Компонент с правилами игры лабиринт
 */
export function MazeRules() {
  const t = useTranslations();

  return (
    <div className="space-y-4 text-sm">
      <div>
        <h4 className="font-semibold text-foreground mb-2">
          {t('games.maze.rules.objective')}
        </h4>
        <p className="text-muted-foreground">
          {t('games.maze.rules.objectiveText')}
        </p>
      </div>

      <div>
        <h4 className="font-semibold text-foreground mb-2">
          {t('games.maze.rules.howToPlay')}
        </h4>
        <ul className="list-disc list-inside space-y-1 text-muted-foreground">
          <li>{t('games.maze.rules.step1')}</li>
          <li>{t('games.maze.rules.step2')}</li>
          <li>{t('games.maze.rules.step3')}</li>
          <li>{t('games.maze.rules.step4')}</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-foreground mb-2">
          {t('games.maze.rules.difficulty')}
        </h4>
        <ul className="list-disc list-inside space-y-1 text-muted-foreground">
          <li><strong>{t('games.difficulty.easy.name')}:</strong> {t('games.maze.rules.easyDesc')}</li>
          <li><strong>{t('games.difficulty.medium.name')}:</strong> {t('games.maze.rules.mediumDesc')}</li>
          <li><strong>{t('games.difficulty.hard.name')}:</strong> {t('games.maze.rules.hardDesc')}</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold text-foreground mb-2">
          {t('games.maze.rules.tips')}
        </h4>
        <ul className="list-disc list-inside space-y-1 text-muted-foreground">
          <li>{t('games.maze.rules.tip1')}</li>
          <li>{t('games.maze.rules.tip2')}</li>
          <li>{t('games.maze.rules.tip3')}</li>
        </ul>
      </div>
    </div>
  );
}
